const PHRASE = "Precision Without Compromise — Compliance Without Exception";

export const MarqueeBand = () => (
  <div data-testid="marquee-band" className="marquee-band bg-[#0B1B3D] py-5 border-y border-[#C5A059]/30">
    <div className="marquee-track">
      {[0, 1].map((half) => (
        <div key={half} className="flex items-center shrink-0" aria-hidden={half === 1}>
          {Array.from({ length: 4 }).map((_, i) => (
            <span
              key={i}
              className="font-heading uppercase tracking-[0.35em] text-xs sm:text-sm text-white/85 flex items-center"
            >
              <span className="px-8">{PHRASE}</span>
              <span className="text-[#C5A059]">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
